<script>
/* eslint-disable */
import LeilaoMixin from "components/leiloes/components/LeilaoMixin"
import ERow from "components/layout/components/Row.vue"
import ECol from "components/layout/components/Col.vue"
import Notas from "components/leilao-notas/components/List.vue"

export default {
  name: 'LeilaoNotas',
  inject: ['page'],
  mixins: [LeilaoMixin],
  components: {Notas, ECol, ERow},
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
  },
  meta: {
    title: 'Notas do Leilão',
    name: 'LeilaoNotas'
  }
}
</script>

<template>
  <div class="">
    <div class="content">
      <header>
        <e-row mr>
          <e-col><h2 class="component-title">Notas emitidas do leilão</h2></e-col>
          <e-col class="text-right">
          </e-col>
        </e-row>
      </header>

      <div class="body">
        <notas :leilao="leilao" />
      </div>
    </div>
  </div>
</template>
